export const clearAllCacheBeforeLogin = () => {
  // Clear app storage
  localStorage.clear();
  sessionStorage.clear();

  // Clear i18n cache
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("i18next")) {
      localStorage.removeItem(key);
    }
  });
};
